export default "__VITE_ASSET__Z8c6WpOh__"